// extracted by mini-css-extract-plugin
module.exports = {"CardHolder":"UserDetailCard_CardHolder__KOPd5","userInfoHolder":"UserDetailCard_userInfoHolder__2SQRj","transformButton":"UserDetailCard_transformButton__iriCl"};